import React, { useState } from 'react';
import { Reveal } from '../common/Reveal';
import { Lightbox } from '../common/Lightbox';

/* ── Gallery images organized by category ── */
const GALLERY_DATA = {
  exterior: [
    '/exterior/IMG-20260323-WA0065.jpg',
    '/exterior/IMG-20260323-WA0066.jpg',
    '/exterior/IMG-20260323-WA0067.jpg',
    '/exterior/IMG-20260323-WA0068.jpg',
    '/exterior/IMG-20260323-WA0069.jpg',
    '/exterior/IMG-20260323-WA0071.jpg',
    '/exterior/IMG-20260323-WA0072.jpg',
    '/exterior/IMG-20260323-WA0073.jpg',
    '/exterior/IMG-20260323-WA0074.jpg',
  ],
  interior: [
    '/interior/IMG-20260323-WA0075.jpg',
    '/interior/IMG-20260323-WA0076.jpg',
    '/interior/IMG-20260323-WA0077.jpg',
    '/interior/IMG-20260323-WA0078.jpg',
    '/interior/IMG-20260323-WA0079.jpg',
    '/interior/IMG-20260323-WA0080.jpg',
    '/interior/IMG-20260323-WA0081.jpg',
    '/interior/IMG-20260323-WA0082.jpg',
    '/interior/IMG-20260323-WA0083.jpg',
    '/interior/IMG-20260323-WA0084.jpg',
    '/interior/IMG-20260323-WA0085.jpg',
    '/interior/IMG-20260323-WA0086.jpg',
    '/interior/IMG-20260323-WA0089.jpg',
    '/interior/IMG-20260323-WA0090.jpg',
  ],
  budget: [
    '/budget_homes/IMG-20260323-WA0087.jpg',
    '/budget_homes/IMG-20260323-WA0088.jpg',
    '/budget_homes/IMG-20260323-WA0091.jpg',
    '/budget_homes/IMG-20260323-WA0092.jpg',
    '/budget_homes/IMG-20260323-WA0093.jpg',
  ],
};

const ALL_IMGS = [...GALLERY_DATA.exterior, ...GALLERY_DATA.interior, ...GALLERY_DATA.budget];

export function Gallery() {
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState('all');

  const cats = [
    { key: 'all', label: 'All' },
    { key: 'exterior', label: 'Exterior' },
    { key: 'interior', label: 'Interior' },
    { key: 'budget', label: 'Budget Homes' },
  ];

  const images = filter === 'all' ? ALL_IMGS : GALLERY_DATA[filter] || [];

  /* Premium layout pattern repeats every 6:
     Row A: [span-2-tall] [1] [1]
     Row B: [1] [1] [span-2-tall] 
     This creates a magazine-style asymmetric grid */
  const heights = [
    'row-span-2', '', '',
    '', '', 'row-span-2',
  ];

  const getClass = (i) => {
    const patternIdx = i % 6;
    return heights[patternIdx] || '';
  };

  return (
    <section id="gallery" className="py-20 md:py-28 px-8 md:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <Reveal>
            <div className="text-[0.68rem] font-normal tracking-[0.35em] uppercase text-nestlent-green mb-3">Visual Portfolio</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-[clamp(2.2rem,4vw,3.4rem)] font-light leading-[1.12] text-nestlent-charcoal mb-5">
              Our <em className="font-serif italic text-nestlent-green">Gallery</em>
            </h2>
          </Reveal>
          <Reveal delay={180}>
            <div className="w-16 h-px bg-nestlent-green mx-auto mb-8" />
          </Reveal>

          {/* Category filter buttons */}
          <Reveal delay={220} className="flex flex-wrap justify-center gap-2">
            {cats.map(c => (
              <button
                key={c.key}
                onClick={() => setFilter(c.key)}
                className={`text-[0.72rem] font-normal tracking-[0.12em] uppercase px-5 py-2.5 rounded-full border cursor-pointer transition-all duration-300 ${
                  filter === c.key
                    ? 'text-white bg-nestlent-green border-nestlent-green'
                    : 'text-nestlent-grey bg-transparent border-nestlent-grey-light hover:text-nestlent-green hover:border-nestlent-green'
                }`}
              >
                {c.label}
              </button>
            ))}
          </Reveal>
        </div>

        <Reveal delay={100}>
          <div className="grid grid-cols-2 lg:grid-cols-3 auto-rows-[200px] gap-2">
            {images.map((src, i) => (
              <div
                key={src}
                className={`relative overflow-hidden rounded cursor-pointer group ${getClass(i)}`}
                onClick={() => setSelected(src)}
              >
                <img
                  src={src}
                  alt="Gallery"
                  className="absolute inset-0 w-full h-full object-cover transition-all duration-500 group-hover:scale-[1.05]"
                />
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/0 transition-all duration-400 group-hover:bg-black/40 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full border-2 border-white flex items-center justify-center opacity-0 scale-75 transition-all duration-300 group-hover:opacity-100 group-hover:scale-100">
                    <svg className="text-white w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 5v14M5 12h14"/>
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
      {selected && <Lightbox src={selected} onClose={() => setSelected(null)} />}
    </section>
  );
}
